export const GetDateFromString =  (dateStr) => {
    const self = this;
    if(dateStr === null){
        return "Дата не указана";
    }

    let date = ParseDate(dateStr);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();

    date = dd + '.' + mm + '.' + yyyy;
    return date;
}

export const ParseDate =  (dateStr) =>{
    if (!dateStr) {
        return dateStr;
    }
    if (typeof dateStr == 'string') {
        if (dateStr.indexOf('/Date(') == -1) {
            return new Date(Date.parse(dateStr));
        }
        else {
            return new Date(parseInt(dateStr.slice(6), 10));
        }
    }
    else if (dateStr === null) {
        return dateStr;
    }
    else {
        return dateStr;
    }
}